export const CHANGE_CATEGORIES = "CHANGE_CATEGORIES";
export const CHANGE_FOODS = "CHANGE_FOODS";
export const CHANGE_ALLERGENS = "CHANGE_ALLERGENS";
export const CHANGE_IMAGES = "CHANGE_IMAGES";
export const CHANGE_COUNT = "CHANGE_COUNT";
export const CHANGE_CONNEXION = "CHANGE_CONNEXION";
export const CHANGE_POPUPS = "CHANGE_POPUPS";
export const CHANGE_POPUPC = "CHANGE_POPUPC";


// WEBPACK FOOTER //
// ./src/actions/action-types.js